export default function () {
	if (typeof window === 'undefined') {
		return;
	}

	const isWindows = navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0;

	if (isWindows) {
		return;
	}

	console.log('%cApploud Digital', `color: #b0976d; font-size: 40px; font-weight: bolder; font-family:vodafone, calibri; arial`);
	console.log('%chttp://applouddigital.cz/', `color: #b0976d; text-decoration: underline; font-size: 12px;`);
};
